import styled from 'styled-components';

const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

const TableContainer = styled.div`
  padding: 32px;
`;

const MainPageContainer = styled.div`
  padding: 32px;
`;

const companiesManagementStyle = {
  Heading,
  MainPageContainer,
  TableContainer,
};

export default companiesManagementStyle;
